import { defineMessages } from 'react-intl.macro';

export const messages = defineMessages({
  addReferral: {
    id: 'components.ReferralsHeader.messages.addReferral',
    defaultMessage: 'Add Referral',
  },
  addOutreach: {
    id: 'components.ReferralsHeader.messages.addOutreach',
    defaultMessage: 'Add New Outreach',
  },
  uploadOutreach: {
    id: 'components.ReferralsHeader.messages.uploadOutreach',
    defaultMessage: 'Upload Outreach File',
  },
  uploadReferral: {
    id: 'components.ReferralsHeader.messages.uploadReferral',
    defaultMessage: 'Upload Referrals',
  },
  outreach: {
    id: 'components.ReferralsHeader.messages.outreach',
    defaultMessage: 'OUTREACH',
  },
  referrals: {
    id: 'components.ReferralsHeader.messages.referrals',
    defaultMessage: '{type} Referrals',
  },
});
